module.exports = __webpack_public_path__ + "tc.94b3bd27120e29299b0c.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/tc.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/tc.svg
// module chunks = styles